import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { nebankaOcpRoute } from '../NebankaOcpParentPage/route';

export const nebankaOcpAccountPendingOrdersRoute = createRoute({
	path: '/pending-orders',
	getParentRoute: () => nebankaOcpRoute,
	component: lazyRouteComponent(
		() => import('./NebankaOcpAccountPendingOrdersPage'),
		'NebankaOcpAccountPendingOrdersPage',
	),
});
